module.exports = __webpack_public_path__ + "static/media/pianificazione1.6abe8926.jpg";